import { useEffect } from 'react';

// SEO EXTRÊME - Optimisé pour dominer le marché local
// Injection DOM native (React 19 compatible) — aucun doublon canonical/meta
// Stratégie : Mots-clés longue traîne + Géolocalisation précise + Preuves sociales + Prix compétitifs
export const defaultSEO = {
  home: {
    title: "Le Clown Magicien Bretagne | Arbre de Noël CE & Animation ⭐ 4,9★",
    description: "Arbre de Noël CE, écoles, mairies en Bretagne : spectacle magie, Père Noël pro, barbe à papa, pop-corn, maquillage. Anniversaire dès 110€. Finistère & Morbihan. Devis 24h.",
    keywords: "arbre de noel entreprise Bretagne, arbre de noel CE Finistere, arbre de noel CSE Morbihan, arbre de noel ecole Quimper Brest, Pere Noel professionnel Bretagne, spectacle Noel Finistere, magicien arbre de noel Vannes Lorient, animation fete fin annee entreprise, marche de Noel prestataire, location barbe a papa Noel, machine pop corn Noel, maquillage enfants Noel, clown magicien Bretagne, animation anniversaire enfant Finistere, mascotte Mickey Quimper, mascotte Stitch Brest, Pat Patrouille anniversaire Finistere"
  },
  mascottes: {
    title: "Mascottes Anniversaire Bretagne | Mickey Stitch | Finistère ⭐",
    description: "Location mascotte Bretagne : Mickey, Stitch, Pat Patrouille, Pikachu, Sonic, Mario. Anniversaire enfants Finistère & Morbihan. Devis 24h.",
    keywords: "mascotte anniversaire Bretagne, mascotte Mickey Quimper, mascotte Stitch Brest, Pat Patrouille Chase anniversaire Finistère, mascotte Marcus Morbihan, Pikachu Sonic anniversaire, location mascotte professionnelle domicile, costume Mickey location Lorient, mascotte enfant Vannes"
  },
  anniversaire: {
    title: "Anniversaire Enfant Domicile Bretagne dès 110€ ⭐ 4,9★",
    description: "Anniversaire enfant à domicile en Bretagne dès 110€ : clown magicien, mascottes, château gonflable. Finistère & Morbihan. Devis 24h.",
    keywords: "anniversaire enfant domicile Finistère, fête anniversaire Morbihan pas cher, clown anniversaire Quimper, magicien anniversaire Brest, mascotte anniversaire Lorient, animation anniversaire Vannes, anniversaire enfant Concarneau, fête domicile Morlaix, anniversaire clé en main Bretagne, meilleur animateur anniversaire 29 56"
  },
  spectacles: {
    title: "Spectacle Magie Enfants Bretagne | Arbre Noël CE ⭐ 4,9★",
    description: "Spectacle magie familial interactif en Bretagne. Arbre Noël CE, école, mairie, festival. Clown Guigui et Martin le Lutin. Devis 24h.",
    keywords: "spectacle magie enfants Bretagne 850€, magicien arbre noel CE Finistère, magicien entreprise Morbihan, spectacle clown école Quimper, magicien professionnel Brest, animation magie Lorient, spectacle enfants Vannes, magicien kermesse Saint-Brieuc, spectacle magie Côtes-d'Armor, clown magicien Bretagne"
  },
  animations: {
    title: "Animation Enfants Bretagne | Père Noël & Maquillage ⭐ 4,9★",
    description: "Animations pro enfants Bretagne : Père Noël CE, maquillage, tatouage paillettes, kermesse, mariage. Quimper Brest Lorient Vannes. Devis 24h.",
    keywords: "animation enfants Bretagne, Père Noël entreprise Quimper 300€, maquillage enfants Brest, tatouage paillettes Lorient, animation kermesse Vannes, fête école Finistère, animation mariage Morbihan, Père Noël CE CSE Bretagne"
  },
  location: {
    title: "Location Machines Festives Bretagne | Barbe Papa Pop-corn ⭐",
    description: "Location machines festives Bretagne : barbe à papa, pop-corn, glace italienne, granité. Livraison 30 km offerte Quimper. Devis 24h.",
    keywords: "location barbe papa Bretagne, machine pop-corn Quimper, location glace italienne Brest, granité mariage Lorient, candy bar Vannes, machine festive Finistère, location barbe papa mariage Morbihan, pop-corn fête entreprise"
  },
  contact: {
    title: "Contact Le Clown Magicien Bretagne | 06 35 51 25 82 — Devis 24h",
    description: "Contact & devis gratuit sous 24h. Animation enfants pro en Bretagne : spectacles magie, mascottes, arbres de Noël, location machines. 06 35 51 25 82.",
    keywords: "devis animation Bretagne gratuit, contact clown magicien Quimper, réservation mascotte Brest, tarif spectacle Lorient, prix animation Vannes, devis arbre noel CE Finistère, contact Père Noël Morbihan"
  },
  mentionsLegales: {
    title: "Mentions Légales | Le Clown Magicien - Animation Enfants N°1 Bretagne",
    description: "Mentions légales du site le-clown-magicien.com. Animation enfants professionnelle en Bretagne depuis 15 ans. Finistère, Morbihan, Côtes-d'Armor.",
    keywords: "mentions légales clown magicien, CGU animation enfants Bretagne"
  },
  // NOUVELLES PAGES SEO ANNIVERSAIRE
  anniversaireEnfantFinistere: {
    title: "Anniversaire Enfant Finistère (29) des 110 euros | Animation Domicile Quimper Brest Concarneau Morlaix | Clown Magicien Mascotte | ⭐ 50+ Avis 5★",
    description: "🎂 N°1 ANNIVERSAIRE ENFANT Finistère des 110 euros ! Clown magicien, mascottes Mickey Stitch Pat Patrouille, fête foraine à domicile. Quimper, Brest, Concarneau, Morlaix, Douarnenez. Déplacement GRATUIT 30 km. 500+ fêtes animées - ⭐ 50+ avis 5★ Google !",
    keywords: "anniversaire enfant Finistère, animation anniversaire Quimper, fête anniversaire Brest, anniversaire domicile Concarneau, clown magicien Morlaix, mascotte anniversaire 29, anniversaire enfant pas cher Finistère"
  },
  anniversaireEnfantMorbihan: {
    title: "Anniversaire Enfant Morbihan (56) des 110 euros | Animation Domicile Lorient Vannes Auray Pontivy | Clown Magicien Mascotte | ⭐ 50+ Avis 5★",
    description: "🎂 N°1 ANNIVERSAIRE ENFANT Morbihan des 110 euros ! Clown magicien, mascottes Mickey Stitch Pat Patrouille, fête foraine à domicile. Lorient, Vannes, Auray, Pontivy, Hennebont. 500+ fêtes animées en 15 ans - ⭐ 50+ avis 5★ Google !",
    keywords: "anniversaire enfant Morbihan, animation anniversaire Lorient, fête anniversaire Vannes, anniversaire domicile Auray, clown magicien Pontivy, mascotte anniversaire 56, anniversaire enfant pas cher Morbihan"
  },
  anniversaireThemeBretagne: {
    title: "Anniversaire à Thème Bretagne | Princesse Pirate Super-Héros Magie des 110 euros | Animation Personnalisée Finistère Morbihan | ⭐ 50+ Avis 5★",
    description: "🎭 ANNIVERSAIRE À THÈME Bretagne des 110 euros ! Princesse, Pirate, Super-Héros, Pat Patrouille... Animation sur-mesure avec déguisements et décors. Finistère & Morbihan. Chasse au trésor, spectacle magie thématique !",
    keywords: "anniversaire thème princesse Bretagne, anniversaire pirate Finistère, anniversaire super-héros Morbihan, fête déguisée enfant, anniversaire animation thème Pat Patrouille, chasse au trésor anniversaire"
  },
  animationGouterAnniversaire: {
    title: "Animation Goûter Anniversaire Bretagne | Spectacle Mascotte Mini-Disco des 110 euros | Finistère Morbihan | ⭐ 50+ Avis 5★",
    description: "🎂 Animation GOÛTER ANNIVERSAIRE Bretagne ! Spectacle magie + mascotte + mini-disco pendant le goûter. Je m'occupe des enfants, vous profitez ! Formules des 110 euros. Finistère Morbihan. 500+ goûters animés - Devis GRATUIT !",
    keywords: "animation goûter anniversaire, spectacle goûter enfant, mascotte goûter Bretagne, mini disco anniversaire, animation pendant goûter Finistère, goûter anniversaire Morbihan"
  },
  anniversaire3a6AnsBretagne: {
    title: "Anniversaire 3-6 ans Bretagne | Animation Tout-Petits Mascotte Douce des 110 euros | Finistère Morbihan | ⭐ 50+ Avis 5★",
    description: "🎈 ANNIVERSAIRE 3-6 ANS Bretagne des 110 euros ! Animation DOUCE adaptée aux tout-petits. Mascottes câlines Mickey Stitch Pat Patrouille, magie émerveillante, comptines. Finistère Morbihan. Spécialiste anniversaire 3 ans, 4 ans, 5 ans, 6 ans !",
    keywords: "anniversaire 3 ans Bretagne, anniversaire 4 ans Finistère, anniversaire 5 ans Morbihan, anniversaire 6 ans, animation tout-petit, mascotte douce enfant, fête maternelle"
  },
  anniversaire7a12AnsBretagne: {
    title: "Anniversaire 7-12 ans Bretagne | Magie Fête Foraine des 110 euros | Animation Dynamique Finistère Morbihan | ⭐ 50+ Avis 5★",
    description: "🎮 ANNIVERSAIRE 7-12 ANS Bretagne des 110 euros ! Animations DYNAMIQUES : spectacle magie PRO, fête foraine, défis. Idéal 8 ans, 9 ans, 10 ans, 11 ans, 12 ans. Finistère Morbihan. Ils vont adorer !",
    keywords: "anniversaire 10 ans Bretagne, anniversaire 8 ans Finistère, anniversaire préado Morbihan, animation 7-12 ans, fête foraine anniversaire, anniversaire dynamique"
  },
  feteFoiraineDomicileBretagne: {
    title: "Fête Foraine Anniversaire Domicile Bretagne dès 350€ | Jeux Traditionnels Barbe Papa Château Gonflable | ⭐ NOUVEAU 2026",
    description: "🎡 FÊTE FORAINE ANNIVERSAIRE à domicile Bretagne dès 350€/3h ! Pêche aux canards, tir au ballon, chamboule tout, château gonflable, barbe à papa, tatouages. 12 enfants max. Finistère Morbihan. NOUVEAUTÉ 2026 !",
    keywords: "fête foraine anniversaire domicile, fête foraine enfant Bretagne, jeux kermesse anniversaire, pêche aux canards Finistère, barbe papa anniversaire Morbihan, château gonflable fête"
  },
  // PAGES LOCATION LOCALES
  locationBarbeAPapaFinistere: {
    title: "Location Barbe à Papa Finistère 60€/jour | Quimper Brest Concarneau | Livraison GRATUITE | ⭐ 50+ Avis 5★",
    description: "🍭 LOCATION machine barbe à papa Finistère dès 60€/jour ! Livraison GRATUITE 30 km autour Quimper. Anniversaire, mariage, kermesse. Brest, Concarneau, Morlaix. Sucre inclus - Devis GRATUIT !",
    keywords: "location barbe à papa Finistère, machine barbe papa Quimper, louer barbe à papa Brest, location barbe papa Concarneau, barbe à papa anniversaire 29"
  },
  locationBarbeAPapaMorbihan: {
    title: "Location Barbe à Papa Morbihan | Lorient Vannes Auray | Machine Pro + Livraison | ⭐ 50+ Avis 5★",
    description: "🍭 LOCATION machine barbe à papa Morbihan ! Lorient, Vannes, Auray, Pontivy. Machine professionnelle + sucre inclus. Anniversaire, mariage, kermesse. Devis GRATUIT !",
    keywords: "location barbe à papa Morbihan, machine barbe papa Lorient, louer barbe à papa Vannes, location barbe papa Auray, barbe à papa anniversaire 56"
  },
  // PAGE CLOWN ANNIVERSAIRE
  clownAnniversaireBretagne: {
    title: "Clown Anniversaire Bretagne des 110 euros | Animation Enfant Finistère Morbihan | Spectacle Magie Maquillage | ⭐ 50+ Avis 5★",
    description: "🤡 CLOWN ANNIVERSAIRE Bretagne des 110 euros ! Spectacle magie, maquillage, mini-disco. Animation professionnelle 1h-1h30. Finistère Morbihan. 500+ anniversaires - Clown Guigui 15 ans d'expérience !",
    keywords: "clown anniversaire Bretagne, clown enfant Finistère, animation clown Morbihan, clown magicien anniversaire, clown Quimper Brest Lorient"
  },
  // PAGES MASCOTTES
  mascotteMinnieBretagne: {
    title: "Mascotte Minnie Bretagne des 110 euros | Anniversaire Fille | Duo Mickey+Minnie | ⭐ 50+ Avis 5★",
    description: "🎀 MASCOTTE MINNIE Bretagne des 110 euros ! La préférée des petites filles. Duo Mickey+Minnie 160€. Anniversaire, baptême, baby shower. Finistère Morbihan. Animation douce - Devis GRATUIT !",
    keywords: "mascotte Minnie Bretagne, Minnie anniversaire Finistère, mascotte souris Morbihan, duo Mickey Minnie, mascotte fille"
  },
  mascotteMarioBretagne: {
    title: "Mascotte Mario Bretagne des 110 euros | Anniversaire Jeux Vidéo | Duo Mario+Luigi | ⭐ 50+ Avis 5★",
    description: "🎮 MASCOTTE MARIO Bretagne des 110 euros ! Le héros Nintendo pour anniversaire garçon. Duo Mario+Luigi 160€. Finistère Morbihan. Thème jeux vidéo - Devis GRATUIT !",
    keywords: "mascotte Mario Bretagne, Mario anniversaire Finistère, mascotte Luigi Morbihan, duo Mario Luigi, mascotte Nintendo jeux vidéo"
  },
  mascotteSpidermanBretagne: {
    title: "Mascotte Spider-Man Bretagne des 110 euros | Anniversaire Super-Héros | Marvel Avengers | ⭐ 50+ Avis 5★",
    description: "🕷️ MASCOTTE SPIDER-MAN Bretagne des 110 euros ! Le super-héros Marvel pour anniversaire garçon. Poses iconiques, photos. Finistère Morbihan. Effet WOW garanti - Devis GRATUIT !",
    keywords: "mascotte Spider-Man Bretagne, Spiderman anniversaire Finistère, mascotte super-héros Morbihan, mascotte Marvel, anniversaire Avengers"
  },
  mascotteOlafBretagne: {
    title: "Mascotte Olaf Bretagne des 110 euros | Reine des Neiges | Anniversaire Enfant | ⭐ 50+ Avis 5★",
    description: "❄️ MASCOTTE OLAF Bretagne des 110 euros ! Le bonhomme de neige de Frozen adoré des enfants. Câlins, photos, animation douce. Finistère Morbihan. Parfait anniversaire Reine des Neiges !",
    keywords: "mascotte Olaf Bretagne, Olaf Reine des Neiges, mascotte Frozen Finistère, anniversaire Frozen Morbihan, mascotte bonhomme neige"
  },
  mascotteZootopieBretagne: {
    title: "Mascotte Zootopie Bretagne | UNIQUE ! Judy Hopps & Nick Wilde | Duo Exclusif | ⭐ 50+ Avis 5★",
    description: "🐰🦊 UNIQUE EN BRETAGNE ! Mascottes Zootopie Judy Hopps et Nick Wilde. Seul prestataire avec ces personnages ! Duo 160€. Finistère Morbihan. Exclusivité totale !",
    keywords: "mascotte Zootopie Bretagne, Judy Hopps mascotte, Nick Wilde mascotte, Zootopie unique Bretagne, mascotte exclusive Finistère"
  },
  mascotteRumiKpopBretagne: {
    title: "Mascotte Rumi Kpop Bretagne | UNIQUE ! Tendance Coréenne | Exclusivité Bretagne | ⭐ 50+ Avis 5★",
    description: "✨ UNIQUE EN BRETAGNE ! Mascotte Rumi Kpop tendance coréenne. Seul prestataire ! Parfait pour fans Kpop 8-14 ans. Animation danse Kpop. Finistère Morbihan. Exclusivité !",
    keywords: "mascotte Kpop Bretagne, Rumi Kpop mascotte, mascotte coréenne Finistère, anniversaire Kpop Morbihan, mascotte tendance unique"
  },
  // NOUVELLES PAGES SEO
  locationPopCornFinistere: {
    title: "Location Machine Pop-corn Finistère (29) | Style Cinéma des 110 euros | Quimper Brest Concarneau Morlaix | Livraison GRATUITE | ⭐ 50+ Avis 5★",
    description: "🍿 Location machine pop-corn professionnelle dans le Finistère des 110 euros ! Style cinéma rétro pour anniversaire, mariage, fête. Livraison GRATUITE 30 km Quimper. Quimper, Brest, Concarneau, Morlaix, Landerneau. 50+ avis 5★ !",
    keywords: "location pop-corn Finistère, machine pop-corn Quimper, location pop-corn Brest, pop-corn anniversaire Concarneau, machine cinéma Morlaix, location pop-corn mariage 29"
  },
  locationPopCornMorbihan: {
    title: "Location Machine Pop-corn Morbihan (56) | Style Cinéma des 110 euros | Lorient Vannes Auray | Livraison GRATUITE | ⭐ 50+ Avis 5★",
    description: "🍿 Location machine pop-corn professionnelle dans le Morbihan des 110 euros ! Style cinéma rétro pour anniversaire, mariage, fête. Livraison GRATUITE 30 km. Lorient, Vannes, Auray, Pontivy, Hennebont. 50+ avis 5★ !",
    keywords: "location pop-corn Morbihan, machine pop-corn Lorient, location pop-corn Vannes, pop-corn anniversaire Auray, machine cinéma Pontivy, location pop-corn mariage 56"
  },
  animationMariageEnfantsBretagne: {
    title: "Animation Enfants Mariage Bretagne dès 150€ | Occupez les Petits Pendant Votre Jour J | Finistère Morbihan | ⭐ 50+ Mariages Animés",
    description: "💒 Animation enfants pour mariage en Bretagne dès 150€ ! Maquillage, jeux, magie pour les petits pendant le vin d'honneur et cocktail. Parents sereins, enfants heureux ! Finistère Morbihan. 50+ mariages animés - Devis GRATUIT !",
    keywords: "animation mariage enfants Bretagne, babysitting mariage Finistère, animation vin honneur enfants, mariage enfants Morbihan, animation cocktail mariage, jeux enfants mariage Quimper"
  }
};

// Schema JSON-LD pour SEO local optimisé
export const getLocalBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://le-clown-magicien.com/#business",
  "name": "Le Clown Magicien - Animation Enfants Bretagne",
  "alternateName": ["Clown Guigui", "Martin le Lutin", "Le Clown Magicien Bretagne"],
  "description": "N°1 animation enfants en Bretagne depuis 15 ans. Clown magicien professionnel, mascottes Mickey Stitch Pat Patrouille, spectacles magie, Père Noël. Anniversaires des 110 euros, arbres de Noël CE 850€.",
  "url": "https://le-clown-magicien.com",
  "telephone": "+33635512582",
  "email": "contact@le-clown-magicien.com",
  "image": "https://le-clown-magicien.com/logo.png",
  "priceRange": "€€",
  "currenciesAccepted": "EUR",
  "paymentAccepted": "Cash, Check, Bank Transfer",
  "address": {
    "@type": "PostalAddress",
    "addressRegion": "Bretagne",
    "addressCountry": "FR"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 48.0,
    "longitude": -3.5
  },
  "areaServed": [
    { "@type": "State", "name": "Finistère", "alternateName": "29" },
    { "@type": "State", "name": "Morbihan", "alternateName": "56" },
    { "@type": "State", "name": "Côtes-d'Armor", "alternateName": "22" }
  ],
  "serviceArea": {
    "@type": "GeoCircle",
    "geoMidpoint": { "@type": "GeoCoordinates", "latitude": 48.0, "longitude": -3.5 },
    "geoRadius": "150000"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "reviewCount": "61",
    "bestRating": "5",
    "worstRating": "1"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Services Animation Enfants",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": { "@type": "Service", "name": "Anniversaire enfant à domicile" },
        "price": "90",
        "priceCurrency": "EUR",
        "priceSpecification": { "@type": "PriceSpecification", "minPrice": "90", "priceCurrency": "EUR" }
      },
      {
        "@type": "Offer",
        "itemOffered": { "@type": "Service", "name": "Spectacle de magie" },
        "price": "850",
        "priceCurrency": "EUR"
      },
      {
        "@type": "Offer",
        "itemOffered": { "@type": "Service", "name": "Père Noël entreprise / stand photo" },
        "price": "300",
        "priceCurrency": "EUR",
        "priceSpecification": { "@type": "PriceSpecification", "minPrice": "300", "priceCurrency": "EUR" }
      }
    ]
  },
  "sameAs": [
    "https://www.facebook.com/leclownmagicien",
    "https://www.instagram.com/leclownmagicien"
  ],
  "knowsAbout": [
    "Animation enfants", "Spectacle de magie", "Mascotte anniversaire", "Clown professionnel",
    "Arbre de Noël entreprise", "Père Noël", "Maquillage enfants", "Location barbe à papa"
  ],
  "slogan": "Le N°1 de l'animation enfants en Bretagne depuis 15 ans",
  "foundingDate": "2010",
  "numberOfEmployees": { "@type": "QuantitativeValue", "minValue": 1, "maxValue": 5 }
});

// Schema FAQ pour meilleur référencement
export const getFAQSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer.replace(/<[^>]*>/g, '')
    }
  }))
});

// Schema Service pour chaque prestation
export const getServiceSchema = (service) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": service.name,
  "provider": {
    "@type": "LocalBusiness",
    "@id": "https://le-clown-magicien.com/#business",
    "name": "Le Clown Magicien",
    "url": "https://le-clown-magicien.com",
    "telephone": "+33635512582",
    "priceRange": "€€",
    "image": "https://le-clown-magicien.com/logo.png",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Quimper",
      "postalCode": "29000",
      "addressRegion": "Bretagne",
      "addressCountry": "FR"
    }
  },
  "areaServed": ["Finistère", "Morbihan", "Côtes-d'Armor"],
  "description": service.description,
  "offers": service.price ? {
    "@type": "Offer",
    "price": service.price.replace(/[^0-9]/g, ''),
    "priceCurrency": "EUR"
  } : undefined
});

export function PageSEO({ page, title, description, keywords, canonical, image, type = 'website', noSchema = false }) {
  const baseUrl = 'https://le-clown-magicien.com';

  // Map des noms de page vers les URLs
  const pageToUrl = {
    home: '',
    anniversaire: '/anniversaire',
    mascottes: '/mascottes',
    spectacles: '/spectacles',
    location: '/location',
    animations: '/animations',
    contact: '/contact',
    mentionsLegales: '/mentions-legales',
    anniversaireEnfantFinistere: '/anniversaire-enfant-finistere',
    anniversaireEnfantMorbihan: '/anniversaire-enfant-morbihan',
    anniversaireThemeBretagne: '/anniversaire-theme-bretagne',
    animationGouterAnniversaire: '/animation-gouter-anniversaire',
    anniversaire3a6AnsBretagne: '/anniversaire-3-6-ans-bretagne',
    anniversaire7a12AnsBretagne: '/anniversaire-7-12-ans-bretagne',
    feteFoiraineDomicileBretagne: '/fete-foraine-domicile-bretagne',
    locationBarbeAPapaFinistere: '/location-barbe-a-papa-finistere',
    locationBarbeAPapaMorbihan: '/location-barbe-a-papa-morbihan',
    clownAnniversaireBretagne: '/clown-anniversaire-bretagne',
    mascotteMinnieBretagne: '/mascotte-minnie-bretagne',
    mascotteMarioBretagne: '/mascotte-mario-bretagne',
    mascotteOlafBretagne: '/mascotte-olaf-bretagne',
    mascotteZootopieBretagne: '/mascotte-zootopie-bretagne',
    mascotteRumiKpopBretagne: '/mascotte-rumi-kpop-bretagne',
    locationPopCornFinistere: '/location-pop-corn-finistere',
    locationPopCornMorbihan: '/location-pop-corn-morbihan',
    animationMariageEnfantsBretagne: '/animation-mariage-enfants-bretagne',
  };

  // Support double signature: soit `page` (clé map), soit props directes (title/description/canonical)
  const seo = page ? (defaultSEO[page] || defaultSEO.home) : {};
  const finalTitle = title || seo.title;
  const finalDescription = description || seo.description;
  const finalKeywords = keywords || seo.keywords || '';
  const relativePath = canonical || pageToUrl[page] || '';
  const canonicalUrl = relativePath.startsWith('http') ? relativePath : `${baseUrl}${relativePath}`;
  const ogImage = image || `${baseUrl}/logo.png`;
  const seoKey = page || relativePath || 'default';

  useEffect(() => {
    if (!finalTitle) return;

    // Nettoyage COMPLET de toutes les balises SEO gérées dynamiquement
    document.head.querySelectorAll('link[rel="canonical"]').forEach(el => el.remove());
    document.head.querySelectorAll('[data-page-seo]').forEach(el => el.remove());

    // Title
    document.title = finalTitle;

    // Canonical (une seule et unique)
    const canon = document.createElement('link');
    canon.setAttribute('rel', 'canonical');
    canon.setAttribute('href', canonicalUrl);
    canon.setAttribute('data-page-seo', seoKey);
    document.head.appendChild(canon);

    // hreflang (site francais uniquement — fr-FR + x-default pour la couverture internationale)
    document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach(el => el.remove());
    const hreflangs = [
      { hreflang: 'fr-FR', href: canonicalUrl },
      { hreflang: 'fr', href: canonicalUrl },
      { hreflang: 'x-default', href: canonicalUrl },
    ];
    hreflangs.forEach(({ hreflang, href }) => {
      const alt = document.createElement('link');
      alt.setAttribute('rel', 'alternate');
      alt.setAttribute('hreflang', hreflang);
      alt.setAttribute('href', href);
      alt.setAttribute('data-page-seo', seoKey);
      document.head.appendChild(alt);
    });

    const upsertMeta = (attr, name, value) => {
      if (!value) return;
      // Supprime les meta natives d'index.html qui portent le même nom pour éviter les doublons
      document.head.querySelectorAll(`meta[${attr}="${name}"]`).forEach(el => el.remove());
      const el = document.createElement('meta');
      el.setAttribute(attr, name);
      el.setAttribute('content', value);
      el.setAttribute('data-page-seo', seoKey);
      document.head.appendChild(el);
    };

    upsertMeta('name', 'description', finalDescription);
    if (finalKeywords) upsertMeta('name', 'keywords', finalKeywords);
    upsertMeta('property', 'og:title', finalTitle);
    upsertMeta('property', 'og:description', finalDescription);
    upsertMeta('property', 'og:url', canonicalUrl);
    upsertMeta('property', 'og:type', type);
    upsertMeta('property', 'og:locale', 'fr_FR');
    upsertMeta('property', 'og:site_name', 'Le Clown Magicien - N°1 Bretagne');
    upsertMeta('property', 'og:image', ogImage);
    upsertMeta('property', 'og:image:width', '1200');
    upsertMeta('property', 'og:image:height', '630');
    upsertMeta('property', 'og:image:alt', finalTitle);
    upsertMeta('property', 'og:image:type', 'image/png');
    upsertMeta('name', 'twitter:title', finalTitle);
    upsertMeta('name', 'twitter:description', finalDescription);
    upsertMeta('name', 'twitter:image', ogImage);
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'robots', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
    upsertMeta('name', 'author', 'Le Clown Magicien');
    upsertMeta('name', 'geo.region', 'FR-BRE');
    upsertMeta('name', 'geo.placename', 'Bretagne');

    // Schema LocalBusiness (sauf si désactivé par la page)
    if (!noSchema) {
      const schemaEl = document.createElement('script');
      schemaEl.type = 'application/ld+json';
      schemaEl.setAttribute('data-page-seo', seoKey);
      schemaEl.textContent = JSON.stringify(getLocalBusinessSchema());
      document.head.appendChild(schemaEl);
    }

    return () => {
      document.head.querySelectorAll('[data-page-seo]').forEach(el => el.remove());
    };
  }, [seoKey, finalTitle, finalDescription, finalKeywords, canonicalUrl, ogImage, type, noSchema]);

  return null;
}
